import * as Times from "../Constants/times";
// tslint:disable:variable-name
export const LegacyAuthenticationStorageKey = "sd_legacyAuthentication"; // This key is hardcoded in asd.js currently -- make sure that any update here takes that file into account.
export const LaunchFromASDKey = "sd_launchFromASD";
export const microsoftPrivacyLink = "#/privacy";
export const CaptureTelemetryStorageKey = "sd_captureTelemetry";
export const SuppressTransientViewsStorageKey = "sd_suppressTransientViews";
export const KeystoneIntClientId = "801546d2-55cc-4ff4-b66d-134b1208deb5";
export const FairfaxClientId = "7a1a9bfd-5b3a-4a0c-8eec-437515eef258";
export const KeystoneIntTenantName = "common";
export const KeystoneProdClientId = "801546d2-55cc-4ff4-b66d-134b1208deb5";
export const KeystoneProdTenantName = "common";
export const LegacyIntClientId = "c537c33a-a70d-4302-9a6c-da4740a8d792";
export const LegacyIntTenantName = "servicedeskdev.onmicrosoft.com";
export const LegacyProdClientId = "d2bd0a50-471a-466e-999d-af367999d460";
export const LegacyProdTenantName = "servicedesk.onmicrosoft.com";
export const ChannelsId = "c8b3e0dd-990b-4882-b119-acddfcaa7ace";
// tslint:enable:variable-name

export const MsalScopes = [KeystoneIntClientId + "/.default"];
export const ChannelsScopes = [ChannelsId + "/.default"];

export const caching = {
  mode: "localStorage",
  timing: {
    agentProfile: 4 * Times.hourInMs
  }
};

export enum LoggingVerbosityLevel {
  None = 0,
  Error = 1,
  Warning = 2,
  Information = 3
}

export enum AsimovVerbosityLevel {
  None = 0,
  Error = 1,
  Warning = 2,
  Information = 3
}

export interface ConfigurationDetails {
  cstUrl: string;
  clientId: string;
  channelsId: string;
  tenantName: string;
  loggingVerbosityLevel: LoggingVerbosityLevel;
  asimovVerbosityLevel: AsimovVerbosityLevel;
  sdAuthorizationAppId: number;
  keystoneAuthorizationAppId: number;
  prerequisiteLoadTimeout: number; // 5 minutes
  totalPrerequisiteServiceLoadTimeout: number;
  individualPrerequisiteLoadTimeout: number;
  agentServiceUrl: string;
  safBaseUrl: string;
  inflowServiceBaseUrl: string;
  agentCopilotBaseUrl: string;
  creditsReportingServiceBaseUrl: string;
  KreditoServiceBaseUrl: string;
  maxMessagesToLogFromMsal: number;
  userAccessManagementServiceUrl: string;
  featureControlManagerServiceUrl: string;
  signupCloudScope: string;
  cloudScope?: string;
}
export class ServiceDeskConfig {
  public clientId: string = undefined;
  public channelsId: string = undefined;
  public sdBaseUrl: string = undefined;
  public tenantName: string = undefined;
  public version: string = undefined;
  public logoutUrl: string = undefined;
  public currentEnvironment: string = undefined;
  public isBundled: boolean = undefined;
  public packageVersions: {};
  public manifestRevisions: any;
  public requiredFileSizes: {};
  public loggingVerbosityLevel: LoggingVerbosityLevel = LoggingVerbosityLevel.None;
  public asimovVerbosityLevel: AsimovVerbosityLevel = AsimovVerbosityLevel.None;
  public LoggingVerbosityLevel = LoggingVerbosityLevel;
  public AsimovVerbosityLevel = AsimovVerbosityLevel;
  public sdAuthorizationAppId: number;
  public keystoneAuthorizationAppId: number;
  public prerequisiteLoadTimeout = 300000; // 5 minutes
  public totalPrerequisiteServiceLoadTimeout = 300000;
  public individualPrerequisiteLoadTimeout = 300000;
  public agentServiceUrl: string = undefined;
  public safBaseUrl: string = undefined;
  public inflowServiceBaseUrl: string = undefined;
  public KreditoServiceBaseUrl: string = undefined;
  public agentCopilotBaseUrl: string = undefined;
  public creditsReportingServiceBaseUrl: string = undefined;
  public maxMessagesToLogFromMsal = 50;
  public microsoftPrivacyLink = "#/privacy";
  public msaasProductionUrlPrefix = "https://api.support.microsoft.com/v0/";
  public msaasIntegrationUrlPrefix = "https://api-ppe.support.microsoft.com/v0/";
  public mockDataServiceApi = "https://sdmockdataservice.azure-api.net/";
  public absolutePathBeacons: { [beacon: string]: string } = {};
  public userAccessManagementServiceUrl: string = undefined;
  public featureControlManagerServiceUrl: string = undefined;
  public isSecretCloud: boolean = undefined;
  public msalScopes = MsalScopes;
  public channelsScopes = ChannelsScopes;
  public redirectUri = "";
  public signupCloudScope: string = "";
  public cloudScope: string = "";
  private initialized = false;
  private envDetails = {
    ussecppe: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-canary.azure.microsoft.scloud/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1052,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-canary.cst.services.azure.microsoft.scloud",
      inflowServiceBaseUrl: "https://azapp-inflow-canary-west.appservice.microsoft.scloud",
      creditsReportingServiceBaseUrl: "https://azapp-cst-creditrefundservice-canary-westus.appservice.microsoft.scloud",
      userAccessManagementServiceUrl: "https://useraccessmgmt-canary.cst.services.azure.microsoft.scloud",
      featureControlManagerServiceUrl: "https://featurecontrol-canary.cst.services.azure.microsoft.scloud",
      KreditoServiceBaseUrl: "https://azapp-kredito-canary-west.appservice.microsoft.scloud",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "USSec"
    },
    ussecprod: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.azure.microsoft.scloud/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions.cst.services.azure.microsoft.scloud",
      inflowServiceBaseUrl: "https://inflow.ms.cst.services.azure.microsoft.scloud",
      creditsReportingServiceBaseUrl: "https://creditreporting.ms.cst.services.azure.microsoft.scloud",
      userAccessManagementServiceUrl: "https://useraccessmgmt.cst.services.azure.microsoft.scloud",
      featureControlManagerServiceUrl: "https://featurecontrol.cst.services.azure.microsoft.scloud",
      KreditoServiceBaseUrl: "https://kredito.ms.cst.services.azure.microsoft.scloud",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "USSec"
    },
    usnatppe: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-canary.azure.eaglex.ic.gov/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1052,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-canary.services.eaglex.ic.gov",
      inflowServiceBaseUrl: "https://inflow-canary.ms.cst.services.azure.eaglex.ic.gov",
      creditsReportingServiceBaseUrl: "https://creditreporting-canary.ms.cst.services.azure.eaglex.ic.gov",
      userAccessManagementServiceUrl: "https://useraccessmgmt-canary.cst.services.eaglex.ic.gov",
      featureControlManagerServiceUrl: "https://featurecontrol-canary.cst.services.eaglex.ic.gov",
      KreditoServiceBaseUrl: "https://kredito-canary.ms.cst.services.azure.eaglex.ic.gov",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "USNat"
    },
    usnatprod: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.azure.eaglex.ic.gov/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions.services.eaglex.ic.gov",
      inflowServiceBaseUrl: "https://inflow.ms.cst.services.azure.eaglex.ic.gov",
      creditsReportingServiceBaseUrl: "https://creditreporting.ms.cst.services.azure.eaglex.ic.gov",
      userAccessManagementServiceUrl: "https://useraccessmgmt.cst.services.eaglex.ic.gov",
      featureControlManagerServiceUrl: "https://featurecontrol.cst.services.eaglex.ic.gov",
      KreditoServiceBaseUrl: "https://kredito.ms.cst.services.azure.eaglex.ic.gov",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "USNat"
    },
    airgap: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-airgap.azure.com/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions-aircapi.services.microsoft.com",
      inflowServiceBaseUrl: "https://inflowairgap.cst.services.azure.com",
      creditsReportingServiceBaseUrl: "https://creditreportingairgap.cst.services.azure.com",
      userAccessManagementServiceUrl: "https://useraccessmgmt-airgap.cst.services.azure.com",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://kreditoairgap.cst.services.azure.com",
      maxMessagesToLogFromMsal: 1000,
      signupCloudScope: "FR-sov",
      cloudScope: "Airgap"
    },
    aircapi: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.cstaircapi.services.azure.com/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions-saf.cstaircapi.services.azure.com",
      inflowServiceBaseUrl: "https://cst-inflow.cstaircapi.services.azure.com",
      creditsReportingServiceBaseUrl: "https://creditreportingairgap.cst.services.azure.com",
      userAccessManagementServiceUrl: "https://uam.cstaircapi.services.azure.com",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://cst-kredito.cstaircapi.services.azure.com",
      maxMessagesToLogFromMsal: 1000,
      signupCloudScope: "FR-sov",
      cloudScope: "Aircapi"
    },
    cbv: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.cstcbv.services.azure-test.net/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions-saf.cstcbv.services.azure-test.net",
      inflowServiceBaseUrl: "https://cst-inflow.cstcbv.services.azure-test.net",
      creditsReportingServiceBaseUrl: "https://creditreportingairgap.cst.services.azure.com",
      userAccessManagementServiceUrl: "https://uam.cstcbv.services.azure-test.net",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://cst-kredito.cstcbv.services.azure-test.net",
      maxMessagesToLogFromMsal: 1000,
      signupCloudScope: "FR-sov"
    },
    bleu: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: "e4c3160c-c374-44ad-84d2-ddb8c649cdc8",
      // tenantName: "common",
      cstUrl: "https://cst-services.sovcloud-api.fr/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions-saf-services.sovcloud-api.fr",
      inflowServiceBaseUrl: "https://cst-inflow-services.sovcloud-api.fr",
      creditsReportingServiceBaseUrl: "https://creditreporting.cstbleu.services.azure.com",
      userAccessManagementServiceUrl: "https://uam-services.sovcloud-api.fr",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://cst-kredito-services.sovcloud-api.fr",
      maxMessagesToLogFromMsal: 1000,
      signupCloudScope: "FR-sov"
    },
    fairfaxint: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-int.fairfax.azure.us/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 12110,
      keystoneAuthorizationAppId: 10045,
      prerequisiteLoadTimeout: 9000,
      totalPrerequisiteServiceLoadTimeout: 14000,
      individualPrerequisiteLoadTimeout: 7000,
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-dev.services.azure.us",
      inflowServiceBaseUrl: "https://cst-ms-int.fairfax.azure.us",
      creditsReportingServiceBaseUrl: "",
      userAccessManagementServiceUrl: "",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://cst-ms-int.fairfax.azure.us/kreditoservice",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "Fairfax"
    },
    fairfaxppe: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-canary.fairfax.azure.us/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1052,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-canary.services.azure.us",
      inflowServiceBaseUrl: "https://inflow-canary.cst.services.azure.us",
      creditsReportingServiceBaseUrl: "https://creditreporting-canary.cst.services.azure.us",
      userAccessManagementServiceUrl: "",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://kredito-canary.cst.services.azure.us",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "Fairfax"
    },
    fairfaxprod: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.fairfax.azure.us/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions.services.azure.us",
      inflowServiceBaseUrl: "https://inflow.cst.services.azure.us",
      creditsReportingServiceBaseUrl: "https://creditreporting.cst.services.azure.us",
      userAccessManagementServiceUrl: "",
      featureControlManagerServiceUrl: "",
      KreditoServiceBaseUrl: "https://kredito.cst.services.azure.us",
      maxMessagesToLogFromMsal: 1000,
      cloudScope: "Fairfax"
    },
    mooncakeppe: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-canary.azure.cn/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1052,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-canary.cst.services.azure.cn",
      inflowServiceBaseUrl: "https://inflow-canary.cst.services.azure.cn",
      creditsReportingServiceBaseUrl: "https://creditreporting-canary.cst.services.azure.cn",
      userAccessManagementServiceUrl: "https://useraccessmgmt-canary.cst.services.eaglex.ic.gov",
      featureControlManagerServiceUrl: "https://featurecontrol-canary.cst.services.eaglex.ic.gov",
      KreditoServiceBaseUrl: "https://kredito-canary.cst.services.azure.ucn",
      maxMessagesToLogFromAdal: 1000
    },
    mooncakeprod: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.azure.cn/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions.cst.services.azure.cn",
      inflowServiceBaseUrl: "https://inflow.ms.cst.services.azure.cn",
      creditsReportingServiceBaseUrl: "https://creditreporting.cst.services.azure.cn",
      userAccessManagementServiceUrl: "https://useraccessmgmt.cst.services.azure.cn",
      featureControlManagerServiceUrl: "https://featurecontrol.cst.services.azure.cn",
      KreditoServiceBaseUrl: "https://kredito.ms.cst.services.azure.cn",
      maxMessagesToLogFromAdal: 1000
    },
    dev: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-int.azurewebsites.net/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 12110,
      keystoneAuthorizationAppId: 10045,
      prerequisiteLoadTimeout: 9000,
      totalPrerequisiteServiceLoadTimeout: 14000,
      individualPrerequisiteLoadTimeout: 7000,
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-dev.services.microsoft.com",
      inflowServiceBaseUrl: "https://cst-ingestionservice-test.azurewebsites.net",
      creditsReportingServiceBaseUrl: "https://refund-details-dev.azurewebsites.net",
      maxMessagesToLogFromMsal: 1000,
      userAccessManagementServiceUrl: "https://azurecstusermanagementapi.azurewebsites.net/",
      featureControlManagerServiceUrl: "https://azurecstfeaturecontrolmanagerwebapidev.azurewebsites.net/",
      KreditoServiceBaseUrl: "https://cst-purchaseservice-test.azurewebsites.net"
    },
    int: {
      clientId: KeystoneIntClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneIntTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-int.azurewebsites.net/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.Error,
      sdAuthorizationAppId: 12110,
      keystoneAuthorizationAppId: 10045,
      prerequisiteLoadTimeout: 9000,
      totalPrerequisiteServiceLoadTimeout: 14000,
      individualPrerequisiteLoadTimeout: 7000,
      agentServiceUrl: this.msaasIntegrationUrlPrefix,
      safBaseUrl: "https://supportactions-dev.services.microsoft.com",
      inflowServiceBaseUrl: "https://cst-ingestionservice-test.azurewebsites.net",
      creditsReportingServiceBaseUrl: "https://refund-details-dev.azurewebsites.net",
      maxMessagesToLogFromMsal: 1000,
      userAccessManagementServiceUrl: "https://azurecstusermanagementapi.azurewebsites.net",
      featureControlManagerServiceUrl: "https://azurecstfeaturecontrolmanagerwebapidev.azurewebsites.net",
      KreditoServiceBaseUrl: "https://cst-purchaseservice-test.azurewebsites.net"
    },
    doc: {}, // copied from 'dev' below.
    prod: {
      clientId: KeystoneProdClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneProdTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services.azure.com/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.None,
      sdAuthorizationAppId: 1049,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions-cst2.services.microsoft.com",
      inflowServiceBaseUrl: "https://inflow.cst.services.azure.com",
      creditsReportingServiceBaseUrl: "https://creditreporting.cst.services.azure.com",
      userAccessManagementServiceUrl: "https://azurecstusermanagementapi.azurewebsites.net",
      featureControlManagerServiceUrl: "https://azurecstfeaturecontrolmanagerwebapidev.azurewebsites.net",
      KreditoServiceBaseUrl: "https://kredito.cst.services.azure.com",
      agentCopilotBaseUrl: "https://agentcopilot.azurewebsites.net",
      cloudScope: "Prod"
    },
    ppe: {
      clientId: KeystoneProdClientId,
      channelsId: ChannelsId,
      tenantName: KeystoneProdTenantName,
      // tenantName: "common",
      cstUrl: "https://cst-services-canary.azure.com/",
      loggingVerbosityLevel: LoggingVerbosityLevel.Information,
      asimovVerbosityLevel: AsimovVerbosityLevel.None,
      sdAuthorizationAppId: 1052,
      keystoneAuthorizationAppId: 26,
      prerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      totalPrerequisiteServiceLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      individualPrerequisiteLoadTimeout: 300000, // 5 minutes until we can determine more appropriate timeouts from telemetry.
      agentServiceUrl: this.msaasProductionUrlPrefix,
      safBaseUrl: "https://supportactions-cst.services.microsoft.com",
      inflowServiceBaseUrl: "https://inflow-canary.cst.services.azure.com",
      creditsReportingServiceBaseUrl: "https://creditreporting-canary.cst.services.azure.com",
      userAccessManagementServiceUrl: "https://azurecstusermanagementapi.azurewebsites.net",
      featureControlManagerServiceUrl: "https://azurecstfeaturecontrolmanagerwebapidev.azurewebsites.net",
      KreditoServiceBaseUrl: "https://kredito-canary.cst.services.azure.com",
      agentCopilotBaseUrl: "https://brahmabot.azurewebsites.net",
      cloudScope: "PPE"
    }
  };

  constructor() {
    this.envDetails.doc = this.envDetails.dev;
    this.initialize();
  }

  public applyConfigurationModifiers(
    environment: ConfigurationDetails,
    environmentName: string,
    locationObject: Location
  ) {
    let searchParameter = locationObject.search;
    if (searchParameter) {
      if (searchParameter.charAt(0) == "?") {
        searchParameter = searchParameter.substr(1);
      }

      let splitResults = searchParameter.split("&");
      let canFindQueryString = (target: string): boolean => {
        return splitResults.find((i) => i.toLowerCase() === target) ? true : false;
      };
      let booleanToString = (target: boolean): string => {
        return target ? "true" : "false";
      };
      sessionStorage.setItem(LegacyAuthenticationStorageKey, booleanToString(canFindQueryString("uselegacyauth=true")));
      sessionStorage.setItem(LaunchFromASDKey, booleanToString(canFindQueryString("launchfromasd=true")));
      sessionStorage.setItem(
        CaptureTelemetryStorageKey,
        booleanToString(canFindQueryString("capturetelemetry=true") || canFindQueryString("e2e-automation=true"))
      );
      sessionStorage.setItem(
        SuppressTransientViewsStorageKey,
        booleanToString(canFindQueryString("e2e-automation=true") && !canFindQueryString("forceshowtransientui=true"))
      );
    }
    environment.channelsId = ChannelsId;

    if (sessionStorage.getItem(LegacyAuthenticationStorageKey) === "true") {
      if (environmentName == "prod") {
        environment.clientId = LegacyProdClientId;
        environment.tenantName = LegacyProdTenantName;
      } else {
        environment.clientId = LegacyIntClientId;
        environment.tenantName = LegacyIntTenantName;
      }
    }
  }

  public getMsalConfig(): any {
    if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("FAIRFAX") > -1) {
      let endpointsMap = new Map();
      /* tslint:disable: no-null-keyword */
      endpointsMap.set(".html", null);
      endpointsMap.set(".json", null);
      endpointsMap.set(".md", null);
      /* tslint:enable: no-null-keyword */
      endpointsMap.set("https://cst-services-int.fairfax.azure.us", this.msalScopes);
      endpointsMap.set("https://cst-services-canary.fairfax.azure.us", this.msalScopes);
      endpointsMap.set("https://cst-services.fairfax.azure.us", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        //instance: "https://login.microsoftonline.us/",
        //tenant: this.tenantName,
        authority: "https://login.microsoftonline.us/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
          sessiontimeout: 10800
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    }
    if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("BLEU") > -1) {
      let endpointsMap = new Map();
      /* tslint:disable: no-null-keyword */
      endpointsMap.set(".html", null);
      endpointsMap.set(".json", null);
      endpointsMap.set(".md", null);
      /* tslint:enable: no-null-keyword */
      endpointsMap.set("https://cst-services.sovcloud-api.fr", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        authority: "https://login.sovcloud-identity.fr/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
          sessiontimeout: 10800
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    }
    if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("MOONCAKE") > -1) {
      let endpointsMap = new Map();
      /* tslint:disable: no-null-keyword */
      endpointsMap.set(".html", null);
      endpointsMap.set(".json", null);
      endpointsMap.set(".md", null);
      /* tslint:enable: no-null-keyword */
      endpointsMap.set("https://cst-services-canary.azure.cn", this.msalScopes);
      endpointsMap.set("https://cst-services.azure.cn", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        //instance: "https://login.microsoftonline.us/",
        //tenant: this.tenantName,
        authority: "https://login.partner.microsoftonline.cn/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
          sessiontimeout: 10800
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("USNAT") > -1) {
      let endpointsMap = new Map();
      /* tslint:disable: no-null-keyword */
      endpointsMap.set(".html", null);
      endpointsMap.set(".json", null);
      endpointsMap.set(".md", null);
      /* tslint:enable: no-null-keyword */
      endpointsMap.set("https://cst-services-canary.azure.eaglex.ic.gov", this.msalScopes);
      endpointsMap.set("https://cst-services.azure.eaglex.ic.gov", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        // instance: "https://login.microsoftonline.eaglex.ic.gov/",
        // tenant: this.tenantName,
        authority: "https://login.microsoftonline.eaglex.ic.gov/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
          sessiontimeout: 10800
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("USSEC") > -1) {
      let endpointsMap = new Map();
      /* tslint:disable: no-null-keyword */
      endpointsMap.set(".html", null);
      endpointsMap.set(".json", null);
      endpointsMap.set(".md", null);
      /* tslint:enable: no-null-keyword */
      endpointsMap.set("https://cst-services-canary.azure.microsoft.scloud", this.msalScopes);
      endpointsMap.set("https://cst-services.azure.microsoft.scloud", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        // instance: "https://login.microsoftonline.microsoft.scloud/",
        // tenant: this.tenantName,
        authority: "https://login.microsoftonline.microsoft.scloud/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000 // time before token renewal response from AAD is considered timed out
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("PPE") > -1) {
      let endpointsMap = new Map();
      endpointsMap.set("https://cst-services-int.azurewebsites.net", this.msalScopes);
      endpointsMap.set("https://cst-services-canary.portal.azure.com", this.msalScopes);
      endpointsMap.set("https://cst-services-canary.azure.com", this.msalScopes);
      endpointsMap.set("https://cst-services.portal.azure.com", this.msalScopes);
      endpointsMap.set("https://cstbeta.azurewebsites.net/", this.msalScopes);
      endpointsMap.set("https://cst-services-int.azurewebsites.net/", this.msalScopes);
      endpointsMap.set("https://servicedesk-devapi.azurewebsites.net/", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        // instance: "https://login.microsoftonline.microsoft.scloud/",
        // tenant: this.tenantName,
        authority: "https://login.microsoftonline.com/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
          sessiontimeout: 10800
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("INT") > -1) {
      let endpointsMap = new Map();
      /* tslint:disable: no-null-keyword */
      endpointsMap.set(".html", null);
      endpointsMap.set(".json", null);
      endpointsMap.set(".md", null);
      /* tslint:enable: no-null-keyword */
      endpointsMap.set("https://cst-services-int.azurewebsites.net", this.msalScopes);
      endpointsMap.set("https://cst-services-canary.portal.azure.com", this.msalScopes);
      endpointsMap.set("https://cst-services-canary.azure.com", this.msalScopes);
      endpointsMap.set("https://cst-services.portal.azure.com", this.msalScopes);
      endpointsMap.set("https://cstbeta.azurewebsites.net/", this.msalScopes);
      endpointsMap.set("https://cst-int.portal.azure.com/", this.msalScopes);
      endpointsMap.set("https://cst-int.azure.com/", this.msalScopes);
      endpointsMap.set("https://servicedesk-devapi.azurewebsites.net/", this.msalScopes);

      endpointsMap.set(this.sdBaseUrl, this.msalScopes);
      endpointsMap.set(this.safBaseUrl, this.msalScopes);
      endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
      endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

      let msalConfig = {
        // instance: "https://login.microsoftonline.microsoft.scloud/",
        // tenant: this.tenantName,
        authority: "https://login.microsoftonline.com/" + this.tenantName,
        clientId: this.clientId,
        clientID: this.clientId,
        optionalParams: {
          channelsId: this.channelsId,
          postLogoutRedirectUri: this.logoutUrl,
          extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
          cacheLocation: "sessionStorage",
          protectedResourceMap: endpointsMap,
          loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
          sessiontimeout: 10800
        },
        tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
      };
      return msalConfig;
    }
    let endpointsMap = new Map();
    /* tslint:disable: no-null-keyword */
    endpointsMap.set(".html", null);
    endpointsMap.set(".json", null);
    endpointsMap.set(".md", null);
    /* tslint:enable: no-null-keyword */
    endpointsMap.set("https://cst-services-int.azurewebsites.net", this.msalScopes);
    endpointsMap.set("https://cst-services-canary.portal.azure.com", this.msalScopes);
    endpointsMap.set("https://cst-services.portal.azure.com", this.msalScopes);
    endpointsMap.set("https://cst-services.azure.com", this.msalScopes);
    endpointsMap.set("https://cstbeta.azurewebsites.net/", this.msalScopes);
    endpointsMap.set("https://cst-services-int.azurewebsites.net/", this.msalScopes);
    endpointsMap.set("https://servicedesk-devapi.azurewebsites.net/", this.msalScopes);
    endpointsMap.set("https://azapp-cst-services-westus2.ase-cst-westus2.p.azurewebsites.net/", this.msalScopes);
    endpointsMap.set("https://azapp-cst-services-westus2.ase-cst-westus2.p.azurewebsites.net", this.msalScopes);
    // For APS
    endpointsMap.set("http://apsuidemo.azurewebsites.net/", this.msalScopes);
    // Note: before removing before out-of-use URL (in our codebase) make sure no partner teams are dependent.
    endpointsMap.set("https://agentservice.trafficmanager.net/", this.msalScopes);
    endpointsMap.set("https://api.support.microsoft.com/v0/contexts", this.channelsScopes);
    endpointsMap.set("https://api-ppe.support.microsoft.com/v0/contexts", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com/v0/transcripts", this.channelsScopes);
    endpointsMap.set("https://api-ppe.support.microsoft.com/v0/transcripts", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com/v0/routingcontexts", this.channelsScopes);
    endpointsMap.set("https://api-ppe.support.microsoft.com/v0/routingcontexts", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com/v1/routes", this.channelsScopes);
    endpointsMap.set("https://api-ppe.support.microsoft.com/v1/routes", this.channelsScopes);
    endpointsMap.set("https://api-ppe.support.microsoft.com/v0/configurations/mappings", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com/v0/configurations/mappings", this.channelsScopes);
    endpointsMap.set("https://api-ppe.support.microsoft.com/v0/locales/microsoft/msaas/locales", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com/v0/locales/microsoft/msaas/locales", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com/", "https://api.support.microsoft.com");
    endpointsMap.set("https://api-ppe.support.microsoft.com/", this.msalScopes);
    endpointsMap.set("https://api.support.microsoft.com/v0/agents", this.channelsScopes);
    endpointsMap.set("https://api.support.microsoft.com", this.msalScopes);

    // For our wildcard domains, make sure current base url also works for MSAL token association.
    endpointsMap.set(this.sdBaseUrl, this.msalScopes);
    endpointsMap.set(this.safBaseUrl, this.msalScopes);
    endpointsMap.set(this.inflowServiceBaseUrl, this.msalScopes);
    endpointsMap.set(this.creditsReportingServiceBaseUrl, this.msalScopes);
    endpointsMap.set(this.userAccessManagementServiceUrl, this.msalScopes);
    endpointsMap.set(this.featureControlManagerServiceUrl, this.msalScopes);
    endpointsMap.set(this.KreditoServiceBaseUrl, this.msalScopes);

    let msalConfig = {
      // instance: "https://login.microsoftonline.com/",
      // tenant: this.tenantName,
      authority: "https://login.microsoftonline.com/" + this.tenantName,
      clientId: this.clientId,
      clientID: this.clientId,
      optionalParams: {
        channelsId: this.channelsId,
        postLogoutRedirectUri: this.logoutUrl,
        extraQueryParameter: "nux=1&domain_hint=" + this.tenantName,
        cacheLocation: "sessionStorage",
        protectedResourceMap: endpointsMap,
        loadFrameTimeout: 20000, // time before token renewal response from AAD is considered timed out
        sessiontimeout: 10800
      },
      tokenReceivedCallback: function (errorDesc: any, token: any, error: any, tokenType: any) {}
    };
    return msalConfig;
  }

  public getGraphApiResource(): string {
    let graphResource: string = "https://graph.microsoft.com";
    if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("BLEU") > -1) {
      graphResource = "https://graph.svc.sovcloud.fr";
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("FAIRFAX") > -1) {
      graphResource = "https://graph.microsoft.us";
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("MOONCAKE") > -1) {
      graphResource = "https://microsoftgraph.chinacloudapi.cn";
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("USNAT") > -1) {
      graphResource = "https://graph.eaglex.ic.gov";
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("USSEC") > -1) {
      graphResource = "https://graph.microsoft.scloud";
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("INT") > -1) {
      graphResource = "https://graph.microsoft.com";
    } else if (this.currentEnvironment && this.currentEnvironment.toUpperCase().indexOf("PPE") > -1) {
      graphResource = "https://graph.microsoft.com";
    }
    return graphResource;
  }

  public getAppInsightsSettings(): any {
    var data = { appInsightsKey: "", endpointUrl: "" };
    switch (this.currentEnvironment.toUpperCase()) {
      case "USSECPPE":
        /* key need to be replaced */
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.applicationinsights.azure.microsoft.scloud/v2/track"
        };
        break;
      case "USSECPROD":
        /* key need to be replaced */
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.applicationinsights.azure.microsoft.scloud/v2/track"
        };
        break;
      case "USNATPPE":
        data = {
          appInsightsKey: "3a7b92fe-ea25-4ae9-b95a-962ff3c96216",
          endpointUrl: "https://dc.applicationinsights.azure.eaglex.ic.gov/v2/track"
        };
        break;
      case "USNATPROD":
        data = {
          appInsightsKey: "b4e4c5de-e051-4d9d-8b62-e1d2816b7954",
          endpointUrl: "https://dc.applicationinsights.azure.eaglex.ic.gov/v2/track"
        };
        break;
      case "AIRGAP":
        data = {
          appInsightsKey: "1a9e7300-612e-4599-bd51-6fc33ff452a0",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      case "AIRCAPI":
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      case "CBV":
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      case "BLEU":
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      case "FAIRFAXINT":
        data = {
          appInsightsKey: "3ccfd1c8-4e31-fb4c-83dd-ba4c03aa4de6",
          endpointUrl: "https://dc.applicationinsights.us/v2/track"
        };
        break;
      case "FAIRFAXPPE":
        data = {
          appInsightsKey: "da48069d-0bdd-f4ac-97fd-67c2ca3a7e1c",
          endpointUrl: "https://dc.applicationinsights.us/v2/track"
        };
        break;
      case "FAIRFAXPROD":
        data = {
          appInsightsKey: "00b0bbd6-414d-f48b-965f-a40d27d8ad6b",
          endpointUrl: "https://dc.applicationinsights.us/v2/track"
        };
        break;
      case "MOONCAKEPPE":
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.applicationinsights.azure.cn/v2/track"
        };
        break;
      case "MOONCAKEPROD":
        data = {
          appInsightsKey: "00000000-0000-0000-0000-000000000000",
          endpointUrl: "https://dc.applicationinsights.azure.cn/v2/track"
        };
        break;
      case "PROD":
        data = {
          appInsightsKey: "c6211438-0028-40cc-a3e3-418a40031242",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      case "PPE":
        data = {
          appInsightsKey: "33c6560c-6668-4c51-8b9a-4f76bd221550",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      case "INT":
        data = {
          appInsightsKey: "181a44c1-3279-4a72-bf7f-8b28ec71d207",
          endpointUrl: "https://dc.services.visualstudio.com/v2/track"
        };
        break;
      default:
        throw new Error("Failed to get appInsightsKey");
    }
    return data;
  }

  public setLoggingVerbosityLevel(value: LoggingVerbosityLevel) {
    this.loggingVerbosityLevel = value;
  }

  public isPreProd(): boolean {
    return this.currentEnvironment && this.currentEnvironment != "prod";
  }

  public initialize() {
    if (this.initialized) {
      throw new Error("Cannot initialized SDConfig more than once.");
    }
    let envName: string = $("#configTag").text().trim();
    if (envName) {
      envName = envName.toLowerCase();
    }
    let bundledName = $("#bundleTag").text().trim();
    if (bundledName) {
      this.isBundled = bundledName.toLowerCase() != "none";
    }

    let manifestRevisionsJson = $("#manifestRevTag").text().trim();
    if (manifestRevisionsJson) {
      this.manifestRevisions = JSON.parse(manifestRevisionsJson);
    }

    let packageDetails = $("#packageVersionTag").text().trim();
    if (packageDetails) {
      this.packageVersions = JSON.parse(packageDetails);
    }

    let fileSizes = $("#requiredFileSizesTag").text().trim();
    if (fileSizes) {
      this.requiredFileSizes = JSON.parse(fileSizes);
    }

    // Allow server generated index to inform where packages should be located.
    let absolutePathBeaconsQuery = $("#absolutePathBeacons");
    if (absolutePathBeaconsQuery.length) {
      this.absolutePathBeacons = JSON.parse(absolutePathBeaconsQuery.text().trim());
    }

    // Allow server generated index to inform where our base URL should be located.
    let baseUrlOverrideQuery = $("#sdServicesBaseUrl");
    let baseUrlOverride = undefined;
    if (baseUrlOverrideQuery.length) {
      baseUrlOverride = baseUrlOverrideQuery.text().trim();
    }

    this.version = $("#versionTag").text().trim();
    this.initialized = true;
    let currentEnv: ConfigurationDetails = undefined;
    this.currentEnvironment = envName ? envName : "dev";
    let environmentNames = Object.getOwnPropertyNames(this.envDetails);
    let matchingIndex = environmentNames.indexOf(this.currentEnvironment);
    if (matchingIndex < 0) {
      throw new Error(`Invalid configuration detected -- '${currentEnv}' is not a valid environment name.`);
    }
    currentEnv = (<any>this.envDetails)[environmentNames[matchingIndex]];
    this.applyConfigurationModifiers(currentEnv, this.currentEnvironment, location);

    this.sdBaseUrl = baseUrlOverride || currentEnv.cstUrl;

    // We modify the sdBaseUrl if we are at a *servicedesk.microsoft.com domain -- this is meant to programmatically support alternate hostnames.
    // NOTE: This does not account for servicedesk-int.microsoft.com, which is not in the initial wildcard domain push.
    if (window.location.hostname.toLowerCase().endsWith("servicedesk.microsoft.com") && !baseUrlOverride) {
      this.sdBaseUrl = window.location.protocol + "//" + window.location.hostname + "/";
    }

    let currentLocation = window.location.href.toLowerCase() + "/";
    // Note: Assumptions are made in sdApp about the QSP structure of the below URL, if you modify it, this may need to be rectified.
    this.logoutUrl =
      (currentLocation.includes(this.envDetails.dev.cstUrl) || currentLocation.includes(this.envDetails.prod.cstUrl)
        ? currentEnv.cstUrl
        : `${window.location.protocol}//${window.location.hostname}:${window.location.port}${window.location.pathname}`) +
      "#/logout/";
    this.clientId = currentEnv.clientId;
    this.channelsId = currentEnv.channelsId;
    this.tenantName = currentEnv.tenantName;
    this.loggingVerbosityLevel = currentEnv.loggingVerbosityLevel;
    this.asimovVerbosityLevel = currentEnv.asimovVerbosityLevel;
    this.sdAuthorizationAppId = currentEnv.sdAuthorizationAppId;
    this.keystoneAuthorizationAppId = currentEnv.keystoneAuthorizationAppId;
    this.prerequisiteLoadTimeout = currentEnv.prerequisiteLoadTimeout;
    this.totalPrerequisiteServiceLoadTimeout = currentEnv.totalPrerequisiteServiceLoadTimeout;
    this.individualPrerequisiteLoadTimeout = currentEnv.individualPrerequisiteLoadTimeout;
    this.agentServiceUrl = currentEnv.agentServiceUrl;
    this.safBaseUrl = currentEnv.safBaseUrl;
    this.inflowServiceBaseUrl = currentEnv.inflowServiceBaseUrl;
    this.KreditoServiceBaseUrl = currentEnv.KreditoServiceBaseUrl;
    this.maxMessagesToLogFromMsal = currentEnv.maxMessagesToLogFromMsal;
    this.creditsReportingServiceBaseUrl = currentEnv.creditsReportingServiceBaseUrl;
    this.userAccessManagementServiceUrl = currentEnv.userAccessManagementServiceUrl;
    this.featureControlManagerServiceUrl = currentEnv.featureControlManagerServiceUrl;
    this.agentCopilotBaseUrl = currentEnv.agentCopilotBaseUrl;

    this.isSecretCloud =
      this.currentEnvironment &&
      (this.currentEnvironment.toUpperCase().indexOf("USNAT") > -1 ||
        this.currentEnvironment.toUpperCase().indexOf("USSEC") > -1);
    this.signupCloudScope = currentEnv.signupCloudScope;
    this.cloudScope = currentEnv.cloudScope || "";
  }
}
